<script setup lang="ts">
import WorkspaceAttentionSection from '@/components/workspace/WorkspaceAttentionSection.vue';
import type { ClientOverviewAttentionCard } from './types';

interface Props {
    cards: ClientOverviewAttentionCard[];
    briefing?: string;
}

defineProps<Props>();

const emit = defineEmits<{
    (e: 'open-card', cardId: string): void,
}>();
</script>

<template>
    <WorkspaceAttentionSection
        :items="cards"
        :briefing="briefing"
        description="Priority actions, active onboarding, and work waiting for a response."
        @open="emit('open-card', $event)"
    />
</template>
